import FormCore from '../../form-core';
import withProvider from '../../withProvider';
import Html from '../../widgets/fields/html';
export default withProvider(FormCore, {
  Html: Html
});